import {create} from 'zustand';

interface OffersFilterState {
  selectedBrand: string | null;
  selectedCategory: string | null;
  selectedCategories: number[];
  searchQuery: string;
  selectedSort: string | null;
  selectedPackaging: string | null;
  setSelectedBrand: (brand: string | null) => void;
  setSelectedCategory: (category: string | null) => void;
  setSelectedCategories: (categoryIds: number[]) => void;
  setSearchQuery: (query: string) => void;
  setSelectedSort: (sort: string | null) => void;
  setSelectedPackaging: (packaging: string | null) => void;
  resetFilters: () => void;
}

const initialState = {
  selectedBrand: null,
  selectedCategory: null,
  selectedCategories: [] as number[],
  searchQuery: '',
  selectedSort: null,
  selectedPackaging: null,
};

export const useOffersFilterStore = create<OffersFilterState>(set => ({
  ...initialState,
  setSelectedBrand: (brand) => set({selectedBrand: brand}),
  setSelectedCategory: (category) => set({selectedCategory: category}),
  setSelectedCategories: (categoryIds) => set({selectedCategories: categoryIds}),
  setSearchQuery: (query) => set({searchQuery: query}),
  setSelectedSort: (sort) => set({selectedSort: sort}),
  setSelectedPackaging: (packaging) => set({selectedPackaging: packaging}),
  resetFilters: () => set(initialState),
}));
